import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.837 12.5a3.5 3.5 0 1 0 6.326 0m-6.326 0a3.5 3.5 0 0 1 6.326 0m-6.326 0H13.5m-3.337 0h.337m0 0h3m-3 0v-4m-6.663 4a3.5 3.5 0 1 0 6.326 3 3.5 3.5 0 0 0-6.326-3Zm0 0L5.92 7.026a2.368 2.368 0 0 1 4.58.842V8.5m3 4v-4m6.663 4-2.082-5.474a2.368 2.368 0 0 0-4.58.842V8.5m-3.001 0h3",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }